export enum ModulesEnum {
  Auth = 'auth',
  Dashboard = 'dashboard',
  PostDispatch = 'postdispatch',
  DriverManagement = 'drivermanagement',
  Zones = 'zones',
  Financials = 'financials',
  Reports = 'reports',
  CartrackTracker = 'cartracktracker',
  Admin = 'admin',
  Banking = 'banking',
  OrderManagement = 'ordermanagement'
}

export enum ModulesGroupingEnum {
  financials = 'financials',
  planning = 'planning',
  general = 'general',
}
